import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ dataComponents: { filterChips } }: ComposedTheme) => ({
  root: {
    marginTop: 16,
    display: 'flex',
    alignItems: 'flex-start',
  },
  label: {
    fontFamily: filterChips.label.text.fontFamily,
    color: filterChips.label.text.color,
    fontSize: filterChips.label.text.fontSize,
    fontWeight: filterChips.label.text.fontWeight,
    margin: 0,
  },
  filterWrap: {
    marginLeft: 16,
    marginRight: 24,
  },
  display: {
    fontFamily: filterChips.groupLabel.font.fontFamily,
    fontSize: filterChips.groupLabel.font.fontSize,
    fontWeight: filterChips.groupLabel.font.fontWeight,
    color: filterChips.groupLabel.font.color,
    margin: 0,
    position: 'relative',
    top: -2,
  },
  count: {
    fontFamily: filterChips.count.text.font.fontFamily,
    fontSize: filterChips.count.text.font.fontSize,
    fontWeight: filterChips.count.text.font.fontWeight,
    color: filterChips.count.text.color,
    marginLeft: 8,
  },
  conditionWrap: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 5,
  },
  filterButton: {
    fontFamily: filterChips.chip.text.font.fontFamily,
    fontSize: filterChips.chip.text.font.fontSize,
    fontWeight: filterChips.chip.text.font.fontWeight,
    color: filterChips.chip.text.color,
    margin: 0,
    marginRight: 8,
    padding: 0,
  },
  condition: {
    marginRight: 8,
  },
});

export default createUseStyles(styles);
